import { Link } from 'react-router';

import Button from '@cartwhl/ui/input/Button';

import SectionHeader from 'components/SectionHeader';

import IntroSection from './IntroSection';
import TableSection from './TableSection';
import TrialSection from './TrialSection';
import GreenLink from 'components/GreenLink';
import { useModal } from 'modals';

export default function ApiPricingPage() {
  const { open } = useModal();
  return (
    <div className="flex flex-col [--vertical-spacing:64px] lg:[--vertical-spacing:112px]">
      <section className="container flex items-center justify-between pt-20">
        <SectionHeader
          title="API Pricing"
          description="How API pricing works"
        />

        <Link to="/canvas-pricing" className="hidden sm:block">
          <Button className="px-10">View Canvas plan</Button>
        </Link>
      </section>

      <IntroSection />

      <TableSection />

      <Link
        to="/canvas-pricing"
        className="container mb-[64px] block sm:hidden"
      >
        <Button className="w-full">View Canvas plan</Button>
      </Link>

      <GreenLink onClick={() => open('ENTERPRISE_CONTACT', { reason: 'request_api_access' })} className="container mb-24">
      Request API access
      </GreenLink>

      <TrialSection />
    </div>
  );
}
